import { ConnectError } from '@bufbuild/connect';
import cn from 'classnames';
import { FC, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ErrorText, Modal, ModalProps } from '@/shared/ui';

import { useRemoveReport_DEPRECATED } from '../../hooks/useRemoveReport';

import styles from './RemoveReportModal.module.scss';

type RemoveReportModalProps = {
  reportIDs?: string[];
  className?: string;
  testID?: string;
} & Pick<ModalProps, 'isOpen' | 'onCancel'>;

/**
 * @deprecated
 */
export const RemoveReportModal_DEPRECATED: FC<RemoveReportModalProps> = (
  props,
) => {
  const { className, testID, isOpen, onCancel: onClose, reportIDs } = props;

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const { formatMessage } = useIntl();

  const removeReport = useRemoveReport_DEPRECATED();

  const handleClose = () => {
    setErrorMessage(undefined);
    if (onClose) {
      onClose();
    }
  };

  const handleRemoveReport = async () => {
    setLoading(true);

    try {
      // TODO: Replace with removeAllReports call once implemented on the backend. Current implementation deletes reports one by one, which may be inefficient for large numbers
      if (reportIDs && reportIDs.length > 0) {
        await Promise.all(reportIDs.map((id) => removeReport(id)));
      }
    } catch (error) {
      setErrorMessage((error as ConnectError)?.message);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  return (
    <Modal
      data-component="remove-report-modal"
      className={cn(styles.container, className)}
      data-testid={testID}
      bodyClassName={styles.modalBody}
      title={formatMessage({
        id: 'removeReportModal.title',
        defaultMessage: 'Remove report',
      })}
      isOpen={isOpen}
      onCancel={handleClose}
      onOk={handleRemoveReport}
      okButtonText={formatMessage({
        id: 'global.applyRemove',
        defaultMessage: 'Yes, remove',
      })}
      okButtonProps={{
        danger: true,
        loading: isLoading,
      }}
    >
      <FormattedMessage
        id="removeReportModal.message"
        defaultMessage="After removing, all report data will be lost. Are you sure?"
      />
      <ErrorText className={styles.errorText} error={errorMessage} />
    </Modal>
  );
};
